import { SearchCustomersResponse } from "@ubif/util-store";

/** Whether quick-search should skip WO / arrival / SO fetches for the customers chip. */
export const shouldSkipCustomerJobSearch = (
  searchCategory: string,
  customersSearchCategory: string,
  searchedCustomersData?: SearchCustomersResponse
): boolean =>
  searchCategory !== customersSearchCategory || !searchedCustomersData || searchedCustomersData.length === 0;
